import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Check } from 'lucide-react';

export default function LifeCraftSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id') || '';
  const saveId = searchParams.get('save_id') || '';
  const sessionIdShort = sessionId ? sessionId.slice(0, 12) + '…' : '';

  return (
    <div className="min-h-screen bg-slate-950 text-gray-200">
      {/* Top nav — back to LifeCraft product page */}
      <nav className="border-b border-purple-500/20 bg-slate-950/80 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <Link
            to="/lifecraft"
            className="inline-flex items-center gap-2 text-purple-300 hover:text-purple-200 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="font-medium">LifeCraft</span>
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <main className="flex flex-col items-center justify-center px-4 sm:px-8 py-12 sm:py-20">
        <motion.div
          className="w-full max-w-md text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Success icon */}
          <motion.div
            className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-green-500/15 border border-green-400/30"
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.1, ease: 'backOut' }}
          >
            <Check className="h-10 w-10 text-green-400" strokeWidth={3} />
          </motion.div>

          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3">
            Payment confirmed
          </h1>
          <p className="text-lg sm:text-xl text-purple-300 mb-6">
            Your save has been unlocked
          </p>

          <p className="text-gray-400 leading-relaxed mb-8">
            Thanks for your purchase! Your $6.99 unlock for this life is complete.
            Return to LifeCraft on your phone to continue your story.
          </p>

          {/* Save details */}
          {(saveId || sessionId) && (
            <div className="text-left bg-slate-900/60 border border-purple-500/20 rounded-xl p-4 mb-6 font-mono text-xs space-y-1.5 break-all">
              {saveId && (
                <div>
                  <span className="text-gray-500">Save ID: </span>
                  <span className="text-gray-300">{saveId}</span>
                </div>
              )}
              {sessionId && (
                <div>
                  <span className="text-gray-500">Confirmation: </span>
                  <span className="text-gray-300">{sessionIdShort}</span>
                </div>
              )}
            </div>
          )}

          <p className="text-xs text-gray-500 leading-relaxed">
            If LifeCraft doesn't reload automatically, open the app from your home
            screen. Your save will be unlocked on next sync.
          </p>
        </motion.div>
      </main>
    </div>
  );
}
